import React, { Component } from 'react';
import { Logo, Wrapper } from '.';
import './Footer.scss';

const FACEBOOK_TYPE = 'Facebook';
const INSTAGRAM_TYPE = 'Instagram';

class Footer extends Component {
  render() {
    const {
      // location,
      settings,
    } = this.props;
    const {
      footerServiceTitle,
      footerServiceDescription,
      footerLocationTitle,
      footerLocationDescription,
      email,
      socialLinks,
    } = settings;
    const facebookLink = socialLinks.find(link => link.type === FACEBOOK_TYPE);
    const instagramLink = socialLinks.find(link => link.type === INSTAGRAM_TYPE);
    const emailParts = email.text.split('@');
    const isHome = true;
    return (
      <footer className="footer">
        <Wrapper>
          <div className="grid-container">
            <div className="grid-col grid-col-left">
              <Logo size="large" colour="dark" />
            </div>
            <div className="grid-col grid-col-middle">
              <div className="grid-row grid-row-top">
                <div className="footer-val">
                  <span className="footer-label">{footerServiceTitle.text}</span>
                  <span className="footer-info">{footerServiceDescription.text}</span>
                </div>
              </div>
              <div className="grid-row grid-row-bottom has-cols">
                <div className="inner-col inner-col-left">
                  <div className="footer-val">
                    <span className="footer-label">Facebook</span>
                    <a
                      className="footer-info"
                      href={facebookLink.link.url}
                      aria-label="Navigate to our Facebook profile"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <span>Facebook/</span>
                      <span>FranklySteve</span>
                    </a>
                  </div>
                </div>
                <div className="inner-col inner-col-right">
                  <div className="footer-val">
                    <span className="footer-label">Instagram</span>
                    <a
                      className="footer-info"
                      href={instagramLink.link.url}
                      aria-label="Navigate to our Instagram profile"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <span>Instagram/</span>
                      <span>FranklySteve</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-col grid-col-right">
              <div className="grid-row grid-row-top">
                <div className="footer-val">
                  <span className="footer-label">{footerLocationTitle.text}</span>
                  <span className="footer-info">{footerLocationDescription.text}</span>
                </div>
              </div>
              <div className="grid-row grid-row-bottom has-cols">
                <div className="inner-col inner-col-left">
                  <div className="footer-val email-field">
                    <span className="footer-label">Email</span>
                    <a className="footer-info" href={`mailto:${email.text}`}>
                      <span>{`${emailParts[0]}@`}</span>
                      <span>{emailParts[1]}</span>
                    </a>
                  </div>
                </div>
                <div className="inner-col inner-col-right">
                  <div className="footer-val studio-field">
                    <span className="footer-info footer-email">
                      <span>Website by</span>
                      { isHome ? (
                        <a
                          className="studio"
                          href="https://www.littleandbig.com.au/"
                          aria-label="Navigate to Little & Big's website"
                        >
                          <span>Little & Big</span>
                        </a>
                      ) : (
                        <span className="studio">Little & Big</span>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </footer>
    );
  }
}

export default Footer;
